import apiClient from './Api';
const PREFIX = '/promotionalBanners';

const getAllDetails = postData =>
  apiClient({
    url: `${PREFIX}/getalldetails`,
    method: 'POST',
    data: postData,
    headers: { 'x-toggle-access': postData?.promoBanner }
  });

const getBannerHistory = postData =>
  apiClient({
    url: 'promotionalBanners/getbannerhistory',
    method: 'POST',
    data: postData,
    headers: { 'x-toggle-access': postData?.promoBanner }
  });

const getVehicleGallery = postData =>
  apiClient({
    url: `${PREFIX}/getvehiclegallery`,
    method: 'POST',
    data: postData
  });

const getBannerFaqs = postData =>
  apiClient({
    url: 'promotionalBanners/getbannerfaqs',
    method: 'POST',
    data: postData,
    headers: { 'x-toggle-access': postData?.promoBanner }
  });

const saveTemplate = postData =>
  apiClient({
    url: `${PREFIX}/savetemplate`,
    method: 'POST',
    data: postData
  });

const updateTemplate = postData =>
  apiClient({
    url: `${PREFIX}/updatetemplate`,
    method: 'POST',
    data: postData
  });

const deleteTemplate = postData =>
  apiClient({
    url: `${PREFIX}/deletetemplate`,
    method: 'POST',
    data: postData
  });

const updateDealerPromoProcess = postData =>
  apiClient({
    url: `${PREFIX}/updatedealerpromoprocess`,
    method: 'POST',
    data: postData,
    headers: { 'x-toggle-access': postData?.promoBanner }
  });

const resetBannerProcess = postData =>
  apiClient({
    url: `${PREFIX}/resetbannerprocess`,
    method: 'POST',
    data: postData,
    headers: { 'x-toggle-access': postData?.promoBanner }
  });

const applyPromoBanner = postData =>
  apiClient({
    url: `${PREFIX}/applypromobanner`,
    method: 'POST',
    data: postData
  });

const removePromoBanner = postData =>
  apiClient({
    url: `${PREFIX}/removepromobanner`,
    method: 'POST',
    data: postData
  });

const saveFilter = postData =>
  apiClient({
    url: 'promotionalBanners/savefilter',
    method: 'POST',
    data: postData,
    headers: { 'x-toggle-access': postData?.promoBanner }
  });

const deleteFilter = postData =>
  apiClient({
    url: 'promotionalBanners/deletefilter',
    method: 'POST',
    data: postData,
    headers: { 'x-toggle-access': postData?.promoBanner }
  });

const saveBannerFaq = postData =>
  apiClient({
    url: 'promotionalBanners/savebannerfaq',
    method: 'POST',
    data: postData
  });

const deleteBannerFaq = postData =>
  apiClient({
    url: 'promotionalBanners/deletebannerfaq',
    method: 'POST',
    data: postData
  });

const saveFilterPriorities = postData =>
  apiClient({
    url: 'promotionalBanners/savefilterpriorities',
    method: 'POST',
    data: postData
  });

const promotionalBannersService = {
  getAllDetails,
  getBannerHistory,
  getBannerFaqs,
  saveTemplate,
  updateTemplate,
  deleteTemplate,
  updateDealerPromoProcess,
  getVehicleGallery,
  applyPromoBanner,
  removePromoBanner,
  resetBannerProcess,
  saveFilter,
  deleteFilter,
  saveBannerFaq,
  deleteBannerFaq,
  saveFilterPriorities
};

export default promotionalBannersService;
